module.exports = __webpack_public_path__ + "assets/site-greek.fa6b756e.pdf";